// Author YuJiaBei
// Date 2020-12-02 16:57:54

class EmCssIcon {
constructor({
        id = null,
        code = '',
        name = '',
        description = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.description = description;
}
}

function newEntity() {
return new EmCssIcon();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.em.admin.emCssIcon.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emCssIcon.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.admin.emCssIcon.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    codeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.emCssIcon.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.admin.emCssIcon.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.em.admin.emCssIcon.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.emCssIcon.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.admin.emCssIcon.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmCssIcon, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
